import axios from 'axios';
import head from 'lodash/head';
import { urls } from '@/common/constants/const-url';
import { userMapper } from '@/common/helpers/user-helper';
import 'core-js/stable';
import Promise from 'core-js/stable/promise';
import 'regenerator-runtime/runtime';
import { DigitalSign } from '@itbelcom/digital-sign';
import { NBRBAuth2 } from '@itbelcom/nbrb-auth2';
import { UserType } from '@/common/enums/userType';
import { NbrbAuthStatus } from '@/common/enums/nbrbAuthStatus';
import { ExternalRole } from '@/common/enums/ExternalRole';
import * as PortalAuthInstance from '@/common/module/PortalAuthInstance.ts';


export const autorization = {
    data: function () {
        return {
            isBusyObject: {
                initNbrbAuth: false,
                checkAccess: false,
                checkIsNBRBOfIP: false,
                getKeyContainerNames: false,
                login: false,
                getUser: false,
                logout: false,
            },
            isLoading: false,
            isNBRB: false,
            currentUser: null,
            containerList: [],
            portalNbrbAuth: null,
            applicationNrbrAuth: [],
            nbrbAuthAuc: null,
            nbrbAuthDepo: null,
            digitalSign: null,
            digitalSignAuc: null,
            msgError: null,
            isAuthenticated: false,
            config: {},
        };
    },
    computed: {
        isBusy: function () {
            return this.isBusyObject.checkAccess
                || this.isBusyObject.checkIsNBRBOfIP
                || this.isBusyObject.login
                || this.isBusyObject.getUser
                || this.isBusyObject.logout
                || this.isBusyObject.initNbrbAuth;
        },
    },
    created: function () {
        this.initNbrbAuth();
    },
    methods: {
        initNbrbAuth: function () {
            this.isBusyObject.initNbrbAuth = true;
            let axiosInstance = axios.create();

            axiosInstance.interceptors.response.use(response => this.axiosOptionsInit(response),
                function (error) {
                    let out = {
                        $adapter: 'axios',
                        config: error.config,
                        data: null,
                        status: -1,
                        statusText: '',
                        xhrStatus: 'complete'
                    };
                    if (error.response) {
                        out.data = error.response.data;
                        out.status = error.response.status;
                        out.statusText = error.response.statusText;
                        out.xhrStatus = 'complete';
                    }
                    return Promise.reject(out);
                });



            axios.get(urls.urlApplicationConfig)
                .then(response => {
                    if (response.data.isSuccessful) {
                        this.config = response.data.viewModel;
                        this.digitalSign = new DigitalSign({
                            ajax: axiosInstance,
                            baseUrl: this.config.digitalSign,
                        });
                        PortalAuthInstance.getInstance()
                            .then(response => {
                                response.on('ON_LOGOUT', this.clearUser);
                                response.on('ON_LOGIN', this.checkAccess);
                                this.config.authApplications.forEach(appConfig => {
                                    appConfig.ajax = axiosInstance;
                                    this.applicationNrbrAuth.push(new NBRBAuth2(appConfig));
                                }, this);
                                this.checkAccess();
                            });
                    }
                });

            this.isBusyObject.initNbrbAuth = false;
        },
        createNbrbAuth(params, baseUrl) {
            return new NBRBAuth2({
                debug: params.debug,
                ajax: params.axiosInstance,
                baseUrl: baseUrl,
                endpoints: {
                    currentUser: params.currentUser,
                },
                crossPost: {
                    trace: params.trace,
                    channelName: params.channelName,
                    trustedOrigins: params.trustedOrigins,
                }
            });
        },
        axiosOptionsInit: function (response) {
            let out = {
                $adapter: 'axios',
                config: response.config,
                data: response.data,
                status: response.status,
                statusText: response.statusText,
                xhrStatus: 'complete'
            };
            return out;
        },
        checkAccess: function () {
            if (!this.isBusyObject.checkAccess) {
                this.isBusyObject.checkAccess = true;
                PortalAuthInstance.getInstance()
                    .then(response => {
                        response.getData()
                            .then(data => {
                                if (data && data.authToken && (data.authTokenExpires > Date.now())) {
                                    this.isAuthenticated = true;
                                    this.getUser();
                                    if (this.$route.path === urls.login) {
                                        location.href = urls.home;
                                    }
                                } else {
                                    this.clearUser();
                                }
                                this.isBusyObject.checkAccess = false;
                            })
                            .catch(() => {
                                this.clearUser();
                                this.isBusyObject.checkAccess = false;
                            });
                    });
            }
        },
        checkAccessApp: function (appKey) {
            const indexAppInstance = this.config.authApplications.findIndex(config => appKey === config.crossPost.channelName);
            if (indexAppInstance !== -1) {
                return this.applicationNrbrAuth[indexAppInstance].getData()
                    .then(data => {
                        if (data && !data.status && !data.errorMsg) {
                            return Promise.resolve();
                        }
                        return Promise.reject(data.errorMsg || this.$t('application.errorUrlApplicationJson'));
                    });
            } else {
                return Promise.reject(this.$t('application.errorUrlApplicationJson'));
            }
        },
        getKeyContainerNames: function () {
            if (!this.isBusyObject.getKeyContainerNames) {
                if (this.digitalSign) {
                    this.isBusyObject.getKeyContainerNames = true;
                    this.digitalSign.getKeyContainerNames()
                        .then(containers => {
                            this.containerList = containers;
                            this.isBusyObject.getKeyContainerNames = false;
                        })
                        .catch(error => {
                            this.msgError = error.errorMsg;
                            this.isBusyObject.getKeyContainerNames = false;
                        });
                }
            }
        },
        loginWithSignature: function (container, password) {
            this.isLoading = true;
            return PortalAuthInstance.getInstance()
                .then(response => {
                    response.off('ON_LOGIN', this.checkAccess);
                    return response.authChallenge()
                        .then((data) => {
                            const message = data.Challenge;
                            return this.digitalSign.signMessage(message, container, password)
                                .then((data) => {
                                    const signature = data.signature;
                                    return response.auth(message, signature, container)
                                        .then(() => {
                                            return response.getData()
                                                .then((data) => {
                                                    if (data && data.authToken && (data.authTokenExpires > Date.now())) {
                                                        let promiseArray = [];
                                                        this.applicationNrbrAuth.forEach((appNbrbAuth) => {
                                                            promiseArray.push(
                                                                this.loginWithSignatureApp(
                                                                    appNbrbAuth,
                                                                    container,
                                                                    signature,
                                                                    message)
                                                                    .then(() => true, () => true)
                                                            );
                                                        }, this);
                                                        response.on('ON_LOGIN', this.checkAccess);
                                                        return Promise.all(promiseArray);
                                                    }
                                                });
                                        });
                                });
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.msgError = error.errorMsg;
                        });
                });

        },
        loginWithSignatureApp: function (appNbrbAuth, container, signature, message) {
            var versionKey = (appNbrbAuth.getOptions() || {}).versionKey;
            var version = localStorage.getItem(versionKey);
            return appNbrbAuth.auth(message, signature, container, null, null, version)
                .then(() => {
                    return appNbrbAuth.getData()
                        .then((data) => {
                            if (data && data.authToken && (data.authTokenExpires > Date.now())) {
                                //ToDo сделать обработку ошибок
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
                });
        },
        login: function (username, password) {
            this.isLoading = true;
            if (!this.isBusyObject.login) {
                this.isBusyObject.login = true;
                return PortalAuthInstance.getInstance()
                    .then(response => {
                        return response.credAuth(username, password)
                            .then((data) => {
                                this.isAuthenticated = true;
                                this.isBusyObject.login = false;
                                return Promise.resolve(data);
                            })
                            .catch(error => {
                                this.msgError = error.errorMsg;
                                this.isAuthenticated = false;
                                this.isBusyObject.login = false;
                                this.isLoading = false;
                                return Promise.reject(error);
                            });
                    });
            }
            this.isLoading = false;
            this.msgError = this.$t('login.loginBusy');
            return Promise.reject({
                status: NbrbAuthStatus.Error,
                errorMsg: this.msgError
            });
        },
        userAuthorization: function (user) {
            this.currentUser = userMapper(user);
            if (this.currentUser.permissions && this.currentUser.permissions.length) {
                this.$store.commit('updatePermissionsCurrentUser', this.currentUser.permissions);
            }
            if (this.currentUser.limited
                || (this.currentUser.externalRoles.length === 1
                    && head(this.currentUser.externalRoles).id === ExternalRole.Guest)) {
                this.$store.commit('updateUserType', UserType.Guest);
            } else {
                const userType = this.currentUser.isNBRB ? UserType.NBRB : UserType.Organisation;
                this.$store.commit('updateUserType', userType);
            }
        },
        getUser: function () {
            this.isBusyObject.getUser = true;
            PortalAuthInstance.getInstance()
                .then(response => {
                    response.getCurrentUser()
                        .then(response => {
                            if (response.User) {
                                localStorage.isAuthenticated = true;
                                this.userAuthorization(response.User);
                            } else {
                                this.currentUser = null;
                                this.isAuthenticated = false;
                            }
                            this.isBusyObject.getUser = false;
                        })
                        .catch(error => {
                            this.isBusyObject.getUser = false;
                            this.msgError = error.errorMsg;
                        });
                });
        },
        //ToDo возможно нужна будет для получения юзера приложения
        //getUserApp: function (appNbrbAuth) {
        //    this.isBusyObject.getUser = true;
        //    appNbrbAuth.getCurrentUser()
        //        .then(response => {
        //            if (response.User) {
        //                console.log('!!!!!!appNbrbAuth!!!!!!!', response.User);
        //            } else {
        //                this.currentUser = null;
        //                this.isAuthenticated = false;
        //            }
        //            this.isBusyObject.getUser = false;
        //        })
        //        .catch(error => {
        //            console.log('***!!!!GETUSERAuc!!!!****', error);
        //            this.isBusyObject.getUser = false;
        //            this.msgError = error.errorMsg;
        //        });
        //},
        logout: function () {
            if (!this.isBusyObject.logout) {
                this.isBusyObject.logout = true;
                let promiseArray = [];
                this.applicationNrbrAuth.forEach((appNbrbAuth) => {
                    promiseArray.push(
                        appNbrbAuth.logout()
                            .then(() => true, () => true)
                    );
                }, this);
                Promise.all(promiseArray)
                    .then(() => {
                        PortalAuthInstance.getInstance()
                            .then(response => {
                                response.logout()
                                    .then(() => {
                                        this.clearUser();
                                        location.href = urls.login;
                                        this.isBusyObject.logout = false;
                                    })
                                    //ToDo выяснить почему падает logout
                                    .catch(() => {
                                        this.clearUser();
                                        location.href = urls.login;
                                        this.isBusyObject.logout = false;
                                    });
                            });
                    });
            }
        },
        clearUser: function () {
            this.currentUser = null;
            localStorage.isAuthenticated = false;
            this.isAuthenticated = false;
            if (this.$route.path !== urls.login) {
                location.href = urls.login;
            }
        },
        isLoginWithContainer: function () {
            return PortalAuthInstance.getInstance()
                .then(response => {
                    return response.getKeyContainer()
                        .then(container => {
                            return !!container;
                        });
                });
        },
    },
};


// WEBPACK FOOTER //
// ./common/mixins/autorizationMixin.ts